import React from "react";
import { IconType } from "react-icons";

type UnifiedIconProps = {
  icon: IconType;
  fontSize?: string | number;
  color?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
};

export const UnifiedIcon: React.FC<UnifiedIconProps> = ({
  icon,
  fontSize = "1.25rem",
  color = "inherit",
  style = {},
  onClick,
}) => {
  const Icon = icon as React.ComponentType<React.SVGProps<SVGSVGElement>>;
  return (
    <Icon
      style={{ fontSize, color, ...style }}
      onClick={onClick}
      className="unified-icon"
    />
  );
};
